import * as React from 'react'
import { type LeadAssignmentRuleFormProps, initialValues } from './typings'
import { useActions } from './hooks'
import { Formik } from 'formik'
import { LeadAssignmentRuleForm } from './LeadAssignmentRuleForm'
import { useMemo } from 'react'
import { EditCoverageBlockDialog } from './EditCoverageBlockDialog'

export function LeadAssignmentRuleFormWrapper(
  props: LeadAssignmentRuleFormProps,
) {
  const { editValues, isEdit } = props
  const { onSubmit, onValidate, coverageBlockLabels, closeCoverageBlock } =
    useActions(props)

  const values = useMemo(
    () => (editValues ? editValues : initialValues),
    [editValues],
  )
  const isEditPage = isEdit ?? !!editValues

  return (
    <>
      <Formik
        onSubmit={(values, helpers) => onSubmit(values, helpers, values.id)}
        validate={onValidate}
        initialValues={values}
        validateOnMount
      >
        <LeadAssignmentRuleForm isEditPage={isEditPage} />
      </Formik>
      <EditCoverageBlockDialog
        labels={coverageBlockLabels}
        onClose={closeCoverageBlock}
      />
    </>
  )
}
